import { call, put, takeEvery } from "redux-saga/effects";
import { GetGroupsSuccess, GetGroupsFailure } from "../../actions/GetGroups";
import { GET_GROUPS } from "../../constants/GetGroups";
import getRequest from "../../../util/APIHelperGet";
import { baseUrl } from "../../../util/APIBaseUrl";

export const fetchGroupsRequest = async (actions) => {
  const customerId = actions?.payload?.customerId;
  const qs = customerId ? `?customerId=${encodeURIComponent(customerId)}` : "";
  return await getRequest(`${baseUrl}/v4/groups${qs}`, false);
};

function* fetchGroups(params) {
  try {
    const response = yield call(fetchGroupsRequest, params);
    if (response?.ok) {
      yield put(GetGroupsSuccess(response));
    } else {
      yield put(GetGroupsFailure(response));
    }
  } catch (error) {
    console.error(error);
    yield put(GetGroupsFailure(error));
  }
}

export default function* rootSaga() {
  yield takeEvery(GET_GROUPS, fetchGroups);
}
